import React from 'react';
import './Maintenance.scss';
import { MaintenanceIcon } from '../utils/icons';
import { BRANDCHOSEN } from '../hooks/config';
const Maintenance = () => {
    return (
        <div className="container-maintenance">
            <div className="message">
                <div className="icon">
                    <div className={`icon-color-${BRANDCHOSEN}`}>
                    <MaintenanceIcon size={120} />
                    </div>
                </div>
                <div className="text">
                    <p>Estamos en mantenimiento</p>
                    <p>Disculpen las molestias</p>
                </div>
            </div>
        </div>
    )
}

export default Maintenance
